/*
 * Sets the focus on an input element on page load
 */
angular.module('qkr').directive('inputFocus', ($timeout) => ({
        link(scope, element, attrs) {
            scope.$watch(attrs.inputFocus, (val) => {
                if (angular.isDefined(val) && val) {
                    $timeout(() => {
 element[0].focus(); 
});
                }
            }, true);

            element.bind('blur', () => {
                if (angular.isDefined(attrs.inputFocusLost)) {
                    scope.$apply(attrs.inputFocusLost);
                }
            });
        }
    }));



// WEBPACK FOOTER //
// ./src/directives/input_focus.js